import React, { useEffect } from 'react'
import useClinics from '../../../store/clinics/clinicsContext';
import MapComponent from '../../../components/landingPage/MapComponent';
import useWindowSize from '../../../hooks/useWindowSize'

function ChooseClinic({selectedClinic, setSelectedClinic, setCurrentStep}) {

	const [clinics, setClinics] = React.useState([]);
  const size = useWindowSize();

  const { getAllClinics } = useClinics();
    
  const fetchClinics = () => {
    getAllClinics().then(res => {
      setClinics(res)
    })
  }

	useEffect(() => {
		fetchClinics();
  }, [])

  const [submenu, setSubmenu] = React.useState(false);


	return (
    <div className="2xl:h-full" style={{ height: size.width<size.tailwind.xl2 && '600px'}}>
      <MapComponent selectedClinic={selectedClinic} setSelectedClinic={setSelectedClinic} setCurrentStep={setCurrentStep}/>
    </div>
  )
}

export default ChooseClinic
